module.exports = __webpack_public_path__ + "static/media/final.6769899e.png";